import { YupSchemaType } from '../types';
import * as yup from 'yup';

export const StripeEmailSchema: YupSchemaType<{ email: string }> = yup.object().shape({
    email: yup.string().trim().email().required(),
});
